import {
	Card,
	CardHeader,
	CardBody,
	Stack,
	StackDivider,
	Text,
	Box,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalBody,
	ModalCloseButton,
	Button,
	Flex,
	Divider,
	Icon,
	LinkBox,
	useDisclosure,
} from "@chakra-ui/react"
import { BiPencil, BiNotepad, BiReceipt, BiImage } from "react-icons/bi"
import { NavLink } from "react-router-dom"
import { BlackDomeStatuses } from "../Options/BlackDomeStatuses"
import { dateToFormat } from "../Utilities"

export const VendorJobRequestListMobileCard = ({
	jobRequest,
	index,
	jobResponsesRequestIds,
	userPlus,
	vendorServices,
	handleOrderStatus,
}) => {
	const { isOpen, onOpen, onClose } = useDisclosure()

	return (
		<Card w="100%" mb="20px" key={index}>
			<CardHeader
				fontWeight="semibold"
				filter="auto"
				blur={
					!vendorServices.includes(jobRequest.serviceType) ||
					(!userPlus.activePlan && !userPlus.partner)
						? "3px"
						: null
				}
			>
				{jobRequest.locationAddress}
			</CardHeader>
			<CardBody fontSize="sm">
				<Stack divider={<StackDivider />} spacing="1">
					<Box display="flex" justifyContent="space-between">
						<Text fontWeight="semibold">Service Type:</Text>
						<Text> {jobRequest.serviceType}</Text>
					</Box>
					<Box display="flex" justifyContent="space-between">
						<Text fontWeight="semibold">Client:</Text>
						<Text style={{ wordWrap: "break-word", width: "75%" }}>
							{jobRequest.userEmail}
						</Text>
					</Box>
					<Box display="flex" justifyContent="space-between">
						<Text fontWeight="semibold">Preferred Dates:</Text>
						{jobRequest.servicePreferredDates &&
							jobRequest.servicePreferredDates.map((entry, index) => (
								<Stack gap={5} mb="5px" key={index}>
									<Text key={index}>{dateToFormat(entry.date)}</Text>
								</Stack>
							))}
					</Box>
					<Box display="flex" justifyContent="space-between">
						<Text fontWeight="semibold">Job Status:</Text>
						{jobRequest.selectedResponseId &&
							!jobRequest.blackDomeStatus &&
							jobResponsesRequestIds.some(
								(response) =>
									response.responseId === jobRequest.selectedResponseId &&
									response.requestId === jobRequest.id
							) && <Text>Request Booking</Text>}
						{!jobRequest.blackDomeStatus &&
							jobResponsesRequestIds.some(
								(response) => response.requestId === jobRequest.id
							) &&
							!jobRequest.selectedResponseId && <Text>Client Received</Text>}
						{!jobRequest.blackDomeStatus &&
							!jobResponsesRequestIds.some(
								(response) => response.requestId === jobRequest.id
							) &&
							!jobRequest.selectedResponseId && <Text>Response Needed</Text>}
						{!jobRequest.blackDomeStatus &&
							jobRequest.selectedResponseId &&
							!jobResponsesRequestIds.some(
								(response) =>
									response.responseId === jobRequest.selectedResponseId
							) && <Text>Unsuccessful</Text>}
						{jobRequest.blackDomeStatus && (
							<Text>
								{
									BlackDomeStatuses.find(
										(status) => status.value === jobRequest.blackDomeStatus
									).label
								}
							</Text>
						)}
					</Box>
				</Stack>
				<Box gap={3}>
					<Button onClick={onOpen} w="100%" mt="10px">
						Take Action
					</Button>
				</Box>
			</CardBody>

			{/* Modal for Actions */}
			<Modal isOpen={isOpen} onClose={onClose} isCentered>
				<ModalOverlay />
				<ModalContent maxW="400px" borderRadius="md" mx="15px">
					<ModalHeader fontSize="16px" fontWeight="medium" pt={10}>
						Take action on <b>{jobRequest.serviceType}</b> at{" "}
						<b>{jobRequest.locationAddress}</b>
					</ModalHeader>
					<ModalCloseButton />
					<ModalBody p={0}>
						<Flex direction="column" w="100%">
							{!jobResponsesRequestIds.includes(jobRequest.id) &&
								!jobRequest.selectedResponseId && (
									<>
										<LinkBox
											as={NavLink}
											to={`/job-request/${jobRequest.id}`}
											w="100%"
										>
											<Button
												variant="ghost"
												w="100%"
												justifyContent="flex-start"
												py={6}
												h="auto"
												borderRadius={0}
												leftIcon={<Icon as={BiPencil} boxSize={5} mr={2} />}
											>
												Respond to Job Request
											</Button>
										</LinkBox>
										<Divider />
									</>
								)}

							{((userPlus.partner === "BDPS" && userPlus.isAdmin) ||
								userPlus.integrations?.includes("PPW")) && (
								<>
									<Button
										variant="ghost"
										onClick={() => handleOrderStatus(jobRequest)}
										w="100%"
										justifyContent="flex-start"
										py={6}
										h="auto"
										borderRadius={0}
										leftIcon={<Icon as={BiNotepad} boxSize={5} mr={2} />}
									>
										Update Status of Work Order
									</Button>
									<Divider />
								</>
							)}

							<LinkBox
								as={NavLink}
								to={`/job-requests/invoice/${jobRequest.id}`}
								w="100%"
							>
								<Button
									variant="ghost"
									w="100%"
									justifyContent="flex-start"
									py={6}
									h="auto"
									borderRadius={0}
									leftIcon={<Icon as={BiReceipt} boxSize={5} mr={2} />}
								>
									Add Invoice
								</Button>
							</LinkBox>
							<Divider />

							<LinkBox
								as={NavLink}
								to={`/job-requests/completion/${jobRequest.id}`}
								w="100%"
							>
								<Button
									variant="ghost"
									w="100%"
									justifyContent="flex-start"
									py={6}
									h="auto"
									borderRadius={0}
									leftIcon={<Icon as={BiImage} boxSize={5} mr={2} />}
								>
									Add Completed Photos
								</Button>
							</LinkBox>
						</Flex>
					</ModalBody>
				</ModalContent>
			</Modal>
		</Card>
	)
}
